module.exports = __webpack_public_path__ + "static/media/university-overseas-exchange.a6eb59ce.jpg";